import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { AddressClientType } from '../../../../../core';

@JsonConverter
export class AddressClientTypeAdapter implements JsonCustomConvert<AddressClientType | undefined> {
    serialize(type: AddressClientType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): AddressClientType | undefined {
        switch (type) {
            case 'Habitual':
                return AddressClientType.HABITUAL;
            default:
                return AddressClientType.RESIDENCE;
        }
    }
}
